import type { LatestPaymentRecord } from '@/lib/api/types';

/**
 * 주문의 표시용 결제수단을 latest_payment 로부터 도출한다 (#632 F-19).
 *
 * 배경: 기존 API→표시 변환기 2곳이 `paymentMethod: 'Card'` 를 하드코딩해
 * - 미결제 후불 주문에 'Card' 가 선표기되고 (아직 수단 미확정)
 * - 현금으로 결제 완료된 주문도 'Card' 로 오표기됐다.
 *
 * 규칙:
 * - 결제 미확정(latest_payment 부재 또는 is_paid=false)이면 '' — 선표기 금지(fail-closed).
 *   표시 계층(TotalSection)은 '' 일 때 결제수단 행 자체를 숨긴다.
 * - 확정 시 combination_code 첫 세그먼트(method 축, 예: 'cash_manual_postpay' → 'cash')
 *   가 cash/transfer/card 인 경우만 인정. 그 외/누락은 '' (fail-closed).
 */
export function derivePaymentMethod(
  latestPayment: LatestPaymentRecord | null | undefined
): string {
  if (!latestPayment?.is_paid) {
    return '';
  }

  const method = latestPayment.combination_code?.split('_')[0];
  return method === 'cash' || method === 'transfer' || method === 'card' ? method : '';
}
